import type { CoreBrand, CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActiveIntegrations = (
  state: CoreState
): CoreBrand['integrations'] | undefined => {
  return findActiveBrand(state)?.integrations
}
